module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "columns selected-section",
    class: {
      'no-padding': _vm.isOpenedInIFrame
    }
  }, [_c('router-link', {
    staticClass: "nav-item",
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticClass: "return-action",
    class: {
      'return-action-iframe': _vm.isOpenedInIFrame
    }
  }, [_c('icon', {
    staticClass: "arrow-left",
    class: {
      'arrow-left-iframe': _vm.isOpenedInIFrame
    },
    attrs: {
      "name": "chevron-left",
      "height": "22",
      "width": "22"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "return-text",
    class: {
      'hide': _vm.isOpenedInIFrame
    }
  }, [_vm._v("Return")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "column is-7 image-section"
  }, [_c('img', {
    staticClass: "cryptoCurrency-image",
    class: {
      'cryptoCurrency-image-iframe': _vm.isOpenedInIFrame
    },
    attrs: {
      "src": ("/static/" + (_vm.selectedCryptoCurrency.id) + "_large_logo.png")
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "cryptoCurrency-title",
    class: {
      'cryptoCurrency-title-iframe': _vm.isOpenedInIFrame
    }
  }, [_vm._v(_vm._s(_vm.selectedCryptoCurrency.name))]), _vm._v(" "), _c('span', {
    staticClass: "tag is-primary",
    class: {
      'tag-iframe': _vm.isOpenedInIFrame
    }
  }, [_vm._v("Rank " + _vm._s(_vm.selectedCryptoCurrency.rank))]), _vm._v(" "), _c('p', {
    staticClass: "cryptoCurrency-description",
    class: {
      'cryptoCurrency-description-iframe': _vm.isOpenedInIFrame
    }
  }, [_vm._v(_vm._s(_vm.selectedCryptoCurrency.description))]), _vm._v(" "), _c('div', {
    staticClass: "icons-section"
  }, [(_vm.selectedCryptoCurrency.website) ? _c('span', {
    staticClass: "icon"
  }, [_c('a', {
    attrs: {
      "href": _vm.selectedCryptoCurrency.website,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "link",
      "scale": "1.5"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.selectedCryptoCurrency.paper) ? _c('span', {
    staticClass: "icon"
  }, [_c('a', {
    attrs: {
      "href": _vm.selectedCryptoCurrency.paper,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "file-text",
      "scale": "1.5"
    }
  })], 1)]) : _vm._e(), _vm._v(" "), (_vm.selectedCryptoCurrency.github) ? _c('span', {
    staticClass: "icon"
  }, [_c('a', {
    attrs: {
      "href": _vm.selectedCryptoCurrency.github,
      "target": "_blank"
    }
  }, [_c('icon', {
    attrs: {
      "name": "github",
      "scale": "1.5"
    }
  })], 1)]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "column information-section",
    class: {
      'information-section-iframe': _vm.isOpenedInIFrame
    }
  }, [_c('div', {
    staticClass: "dropdown-section hide",
    class: {
      'show': _vm.isOpenedInIFrame
    }
  }, [_c('div', {
    staticClass: "control"
  }, [_c('button', {
    staticClass: "button",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.toggleDropDown
    }
  }, [_vm._v("\n          " + _vm._s(_vm.selectedFiatCurrency) + "\n          "), _c('span', {
    staticClass: "arrow-icon"
  }, [(!_vm.dropDownOpen) ? _c('icon', {
    attrs: {
      "name": "caret-down",
      "height": "13"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.dropDownOpen) ? _c('icon', {
    attrs: {
      "name": "caret-up",
      "height": "13"
    }
  }) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box dropdown",
    class: {
      'is-open': _vm.dropDownOpen, 'transparent': _vm.isOpenedInIFrame
    }
  }, [_c('ul', _vm._l((_vm.fiatCurrencies), function(fiatCurrency) {
    return _c('li', [_c('a', {
      staticClass: "nav-item",
      class: {
        'font-white': _vm.isOpenedInIFrame
      },
      on: {
        "click": function($event) {
          _vm.selectFiatCurrency(fiatCurrency)
        }
      }
    }, [_vm._v(_vm._s(fiatCurrency))])])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "price-section price-select-section",
    class: {
      'price-section-iframe': _vm.isOpenedInIFrame
    }
  }, [_c('p', {
    staticClass: "price-tag price-select-tag"
  }, [_vm._v("Current Price")]), _vm._v(" "), _c('div', {
    staticClass: "control",
    class: {
      'hide': _vm.isOpenedInIFrame
    }
  }, [_c('div', {
    staticClass: "select"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedFiatCurrency),
      expression: "selectedFiatCurrency"
    }],
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.selectedFiatCurrency = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        _vm.selectFiatCurrency($event)
      }]
    }
  }, _vm._l((_vm.fiatCurrencies), function(fiatCurrency) {
    return _c('option', [_vm._v(_vm._s(fiatCurrency))])
  }))])]), _vm._v(" "), _c('p', {
    staticClass: "price-amount",
    class: {
      'price-amount-iframe': _vm.isOpenedInIFrame
    }
  }, [_vm._v(_vm._s(_vm.selectedFiatCurrency) + " " + _vm._s(_vm.selectedCryptoCurrency.selectedPrice) + " \n        "), _c('span', {
    class: {
      'positive-percent-change': _vm.selectedCryptoCurrency.positivePercentChange, 'negative-percent-change': !_vm.selectedCryptoCurrency.positivePercentChange
    }
  }, [_vm._v("\n          (" + _vm._s(_vm.selectedCryptoCurrency.percentChange24h) + "%)\n          "), _c('sub', [_c('a', {
    staticClass: "is-primary percent-tooltip tooltip"
  }, [_c('icon', {
    attrs: {
      "name": "info-circle",
      "height": "15",
      "width": "15"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tooltiptext"
  }, [_vm._v("24h percent change")])], 1)])])])]), _vm._v(" "), _c('div', {
    staticClass: "price-section",
    class: {
      'price-section-iframe': _vm.isOpenedInIFrame
    }
  }, [_c('p', {
    staticClass: "price-tag"
  }, [_vm._v("Circulating Supply")]), _vm._v(" "), _c('p', {
    staticClass: "price-amount",
    class: {
      'price-amount-iframe': _vm.isOpenedInIFrame
    }
  }, [_vm._v(_vm._s(_vm.selectedCryptoCurrency.selectedSupply) + " " + _vm._s(_vm.selectedCryptoCurrency.symbol))])]), _vm._v(" "), _c('div', {
    staticClass: "price-section",
    class: {
      'price-section-iframe': _vm.isOpenedInIFrame
    }
  }, [_c('p', {
    staticClass: "price-tag"
  }, [_vm._v("Market Cap")]), _vm._v(" "), _c('div', {}, [_c('div', {
    staticClass: "price-amount market-cap-price-amount",
    class: {
      'price-amount-iframe': _vm.isOpenedInIFrame
    }
  }, [_vm._v(_vm._s(_vm.selectedFiatCurrency) + " " + _vm._s(_vm.selectedCryptoCurrency.selectedMarketCap) + "\n          "), _c('div', {
    staticClass: "doughnut-chart doughnut-tooltip tooltip",
    class: {
      'hide': _vm.isOpenedInIFrame || !_vm.sharedState.totalMarketCapUSD
    }
  }, [_c('doughnut-chart', {
    attrs: {
      "data": {
        labels: ['Total Market Cap USD', "Selected Crypto Currency Market Cap"],
        datasets: [{
          data: [_vm.globalMarketCapUSD, _vm.selectedCryptoCurrencyMarketCap],
          backgroundColor: [
            '#370628',
            '#fd6721'
          ]
        }]
      },
      "width": 125,
      "height": 50
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "tooltiptext"
  }, [_vm._v(_vm._s(_vm.percentageOfMarketCap))])], 1)])])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42b31c8a","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/body/SelectedHero.vue
// module id = 1073
// module chunks = 1